import React, { useState, useEffect } from 'react';
import { Box, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';
import { SpinnerModal } from 'shared-components';
import { APICall } from '../../../types';
import { startTimer } from '../../../utilities/helpers';

export interface IProps {
  id?: string;
  show: boolean;
  apiCallsInProgress: APICall[];
}

const Loading: React.FC<IProps> = (props: IProps) => {
  const { id, show, apiCallsInProgress = [] } = props;

  const [countDownTime, setCountDownTime] = useState<string | undefined>();
  const [currentInterval, setCurrentInterval] = useState<ReturnType<typeof startTimer> | undefined>();
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(
    () => {
      if (apiCallsInProgress && apiCallsInProgress.length > 0) {
        const apiCall = apiCallsInProgress[0];

        if (apiCall && apiCall.timeToNextCall) {
          setHasFailed(apiCallsInProgress.some((apiCall: APICall) => apiCall.hasFailed === true));

          if (currentInterval) {
            // retry of api call was called before countdown timer finished
            clearInterval(currentInterval);
            setCountDownTime('00');
          }

          setCurrentInterval(
            startTimer(Math.floor(apiCall.timeToNextCall / 1000), setCountDownTime, () => {
              setCountDownTime('00');
            })
          );
        }
      }
    },
    // eslint-disable-next-line
    [apiCallsInProgress]
  );

  const getRetryMessage = () => {
    if (hasFailed) {
      return `Your connection has been lost. Please reconnect and refresh this page.`;
    }
    return `Reconnecting...`;
  };

  return (
    <Box id={`${id}-loading`} display={show ? 'block' : 'block'}>
      <Alert
        status={hasFailed ? 'error' : 'loading'}
        display={apiCallsInProgress && apiCallsInProgress.length > 0 ? 'flex' : 'none'}
        position="fixed"
        top={0}
        left={0}
        right={0}
        borderRadius={0}
        zIndex="modal"
      >
        <AlertIcon />

        <AlertDescription>
          {countDownTime !== undefined && countDownTime !== '00' && countDownTime !== '00:00' && !hasFailed
            ? `Reconnecting in ${countDownTime}...`
            : getRetryMessage()}
        </AlertDescription>
      </Alert>

      <SpinnerModal show={show} />
    </Box>
  );
};

export { Loading };
